export const checkLength = (value: string): boolean => !!(value && value.length > 0);

export const checklengthArray = <T>(array: Array<T>): boolean => !!(array && array.length > 0);
